<template>
  <Card class="mb-4">
    <template #header>
      <h2 class="mb-0" @click="toggleFahrzeugDetails()">Fahrzeug</h2>
    </template>

    <!-- Nutzfahrzeug -->
    <div>
      <label>Nutzfahrzeug</label>
      <div class="d-flex">
        <div class="mr-4">
          <input type="radio" id="nutzfahrzeug_ja" v-bind:value="true" v-model="offer.softfair_nutzfahrzeug"
            class="mr-2" />
          <label for="nutzfahrzeug_ja">Ja</label>
        </div>
        <div>
          <input type="radio" id="nutzfahrzeug_nein" v-bind:value="false" v-model="offer.softfair_nutzfahrzeug"
            class="mr-2" />
          <label for="nutzfahrzeug_nein">Nein</label>
        </div>
      </div>
    </div>

    <!-- PKW -->
    <div v-if="!offer.softfair_nutzfahrzeug">
      <!-- h3>PKW</h3 -->

      <b-row>
        <b-col md="6">
          <h4>HSN</h4>
          <base-input prepend-icon="fas fa-car" placeholder="HSN" v-model="offer.softfair_hsn" name="HSN"
            :rules="{ required: true, max: 4, regex: /[a-zA-Z0-9]+/ }"></base-input>
        </b-col>

        <b-col md="6">
          <h4>TSN</h4>
          <base-input prepend-icon="fas fa-car" placeholder="TSN" v-model="offer.softfair_tsn" name="TSN"
            :rules="{ required: true, max: 3, regex: /[a-zA-Z0-9]+/ }"></base-input>
        </b-col>
      </b-row>

    </div>

    <div>

      <b-row v-if="fetched">

        <b-col md="12">
          <p>
            {{ this.offer.car_brand }} {{ this.offer.car_model }} -
            {{ this.offer.car_kw }} kw / {{ this.offer.car_ps }} PS -
            {{ this.offer.car_haftpflicht }}/{{ this.offer.car_teilkasko }}/{{ this.offer.car_vollkasko }}
          </p>
        </b-col>
      </b-row>



      <b-row>
      <b-col md="6">
              <h4>Erstmalige Zulassung auf Versicherungsnehmer</h4>
            <base-input
              prepend-icon="fas fa-calendar"
              placeholder="Erstmalige Zulassung auf Versicherungsnehmer"
              v-model="offer.softfair_erstmalige_zulassung_auf_versicherungsnehmer"
              name="Erstmalige Zulassung auf Versicherungsnehmer"
              rules="required"
              type="date"
            >
            
            </base-input>
          </b-col>

          <b-col md="6">
              <h4>Erstzulassungsdatum</h4>
            <base-input
              prepend-icon="fas fa-calendar"
              placeholder="Erstzulassungsdatum"
              v-model="offer.softfair_erstzulassungs_datum"
              name="Erstzulassungsdatum"
              rules="required"
              type="date"
            >
            
            </base-input>
          </b-col>

        </b-row>



      <b-row>
        <b-col lg="6">
            <h4>Fahrleistung pro Jahr</h4>
              <base-input
              prepend-icon="fas fa-car"
              placeholder="Fahrleistung pro Jahr"
              v-model="offer.softfair_fahrleistung_pro_jahr"
              name="Fahrleistung pro Jahr"
              rules="required"
            ></base-input>

        </b-col>
        <b-col lg="6">
            <h4>Kilometerstand</h4>
              <base-input
              prepend-icon="fas fa-car"
              placeholder="Kilometerstand"
              v-model="offer.softfair_kilometerstand"
              name="Kilometerstand"
              rules="required"
            ></base-input>
          </b-col>
      </b-row>



      <b-row>
        <b-col lg="6">
          <h4 @click="toggleFahrzeugDetails()">Details</h4>
        </b-col>
        <b-col lg="6" class="text-right">
          <i v-if="show_fahrzeug_details" class="fa fa-chevron-down" @click="toggleFahrzeugDetails()"></i>
          <i v-else class="fa fa-chevron-left" @click="toggleFahrzeugDetails()"></i>
        </b-col>
      </b-row>
      <div v-if="show_fahrzeug_details">
        <BaseCheckbox v-model="offer.softfair_ist_als_betriebsausgabe_anerkannt"
          :checked="offer.softfair_ist_als_betriebsausgabe_anerkannt" :inline="true">Ist als Betriebsausgabe anerkannt
        </BaseCheckbox>
        <BaseSelect v-model="offer.softfair_stellplatz_art" :options="stellplatzArtOptions" :value="stellplatzArtOptions[0]" label="Stellplatz Art" />
        <BaseInput v-model="offer.softfair_manuelle_typklassen" :value="offer.softfair_manuelle_typklassen || ''"
          label="Manuelle Typklassen" />
        <BaseCheckbox v-model="offer.softfair_ist_erstbesitzer" :checked="offer.softfair_ist_erstbesitzer"
          :inline="true">
          Ist Erstbesitzer</BaseCheckbox>
        <BaseInput v-model="offer.softfair_neuwert_euro" :value="offer.softfair_neuwert_euro || ''" type="number"
          label="Neuwert in Euro" />

        <BaseSelect v-model="offer.softfair_fahrzeug_nutzung" :options="fahrzeugNutzungOptions" :value="fahrzeugNutzungOptions[0]"
          label="Fahrzeug Nutzung" />
        <BaseSelect v-model="offer.softfair_ausland_nutzung" :options="auslandNutzungOptions" :value="auslandNutzungOptions[0]" label="Ausland Nutzung" />

      </div>


      <b-row>
        <b-col lg="6">
          <h4 @click="toggleAssistenzsysteme()">Assistenzsysteme</h4>
        </b-col>
        <b-col lg="6" class="text-right">
          <i v-if="show_assistenzsysteme" class="fa fa-chevron-down" @click="toggleAssistenzsysteme()"></i>
          <i v-else class="fa fa-chevron-left" @click="toggleAssistenzsysteme()"></i>
        </b-col>
      </b-row>

      <div v-if="show_assistenzsysteme">
        <BaseSelect v-model="offer.softfair_tagfahrlicht" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]" label="Tagfahrlicht" />
        <BaseSelect v-model="offer.softfair_unfalldatenschreiber" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Unfalldatenschreiber" />
        <BaseSelect v-model="offer.softfair_abstandsregeltempomat" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Abstandsregeltempomat" />
        <BaseSelect v-model="offer.softfair_antiblockiersystem" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Antiblockiersystem" />
        <BaseSelect v-model="offer.softfair_elektronisches_stabilitaetsprogramm" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Elektronisches Stabilitätsprogramm" />
        <BaseSelect v-model="offer.softfair_spurhalteassistent" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Spurhalteassistent" />
        <BaseSelect v-model="offer.softfair_spurwechselassistent" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Spurwechselassistent" />
        <BaseSelect v-model="offer.softfair_elektronische_diebstahlwarnanlage" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Elektronische Diebstahlwarnanlage" />
        <BaseSelect v-model="offer.softfair_nachtsichtassistent" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Nachtsichtassistent" />
        <BaseSelect v-model="offer.softfair_bremsassistent" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]" label="Bremsassistent" />
        <BaseSelect v-model="offer.softfair_fahrzeugortungssystem" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Fahrzeugortungssystem" />
        <BaseSelect v-model="offer.softfair_elektronische_wegfahrsperre" :options="assistenzsystemOptions" :value="assistenzsystemOptions[0]"
          label="Elektronische Wegfahrsperre" />
      </div>



    </div>
  </Card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BaseInput from '@/components/Inputs/BaseInput.vue';
import BaseCheckbox from '@/components/Inputs/BaseCheckbox.vue';
import BaseSelect from '@/components/Inputs/BaseSelect.vue';
import Card from '@/components/Cards/Card.vue';

export default {
  name: "softfair-fahrzeug",
  components: {
    BaseInput,
    BaseCheckbox,
    BaseSelect,
    Card,
  },
  data() {
    return {
      loading: false,
      fetched: false,
      carData: {
      },

      nutzfahrzeugOptions: ['Ja', 'Nein'],
      fahrzeugNutzungOptions: ['AusschliesslichPrivat', 'TeilweiseGewerblich', 'AusschliesslichGewerblich'],
      auslandNutzungOptions: ['Keine', 'Europa', 'Weltweit'],
      assistenzsystemOptions: ['KeineAngaben', 'Ja', 'Nein'],
      stellplatzArtOptions: ['AbschliessbareEinzelDoppelgarage', 'AbgeschlossenerStellplatz', 'FreierStellplatz', 'KeineAngaben'],
      show_fahrzeug_details: false,
      show_assistenzsysteme: false,
    };
  },
  methods: {
    toggleAssistenzsysteme() {
      this.show_assistenzsysteme = !this.show_assistenzsysteme;
    },
    toggleDetails() {
      this.show_details = !this.show_details;
    },
    toggleFahrzeugDetails() {
      this.show_fahrzeug_details = !this.show_fahrzeug_details;
    },
    financial(x) {
      if (isNaN(Number.parseFloat(x).toFixed(2))) {
        return 0;
      }
      return Number.parseFloat(x).toFixed(2);
    },

    fetchCarData() {
      this.loading = true;
      this.$api
        .getCarData(this.offer.softfair_hsn, this.offer.softfair_tsn)
        .then((response) => {
          console.log(response);
          this.carData = response.data;

          this.offer.car_brand = response.data.brand
          this.offer.car_ccm = response.data.ccm
          this.offer.car_haftpflicht = response.data.haftpflicht
          this.offer.car_kw = response.data.kw
          this.offer.car_model = response.data.model
          this.offer.car_ps = response.data.ps
          this.offer.car_teilkasko = response.data.teilkasko
          this.offer.car_vollkasko = response.data.vollkasko
          this.offer.car_hsn = response.data.hsn
          this.offer.car_tsn = response.data.tsn

          this.fetched = true;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleValue: function () {
      this.showValue = !this.showValue;
    },
    toggleUsage: function () {
      this.showUsage = !this.showUsage;
    },

    mayFetchCar() {
      if (
        this.offer.softfair_hsn &&
        this.offer.softfair_hsn.length == 4 &&
        this.offer.softfair_tsn &&
        this.offer.softfair_tsn.length == 3
      ) {
        this.fetchCarData();
        return true;
      }
      return false;
    },
  },

  watch: {
    hsn: {
      handler: function (newValue, oldValue) {
        console.log(`Updating from ${oldValue} to ${newValue}`);
        this.mayFetchCar();
      },
    },
    tsn: {
      handler: function (newValue, oldValue) {
        console.log(`Updating from ${oldValue} to ${newValue}`);
        this.mayFetchCar();
      },
    }
  },
  computed: {
    ...mapGetters({
      currentAccount: "currentAccount",
    }),
    ...mapState({
      offer: (state) => state.softfairOffer,
      hsn: (state) => state.softfairOffer.softfair_hsn,
      tsn: (state) => state.softfairOffer.softfair_tsn,
    }),
  },
  mounted() {
  },
};
</script>
<style></style>